import {
  PARTICIPANT_STATUSES,
  TOURNAMENT_ROLES,
  TOURNAMENT_STATUSES,
} from '@/constants';
import type { ParticipantStatus, TournamentRole, TournamentStatus } from '@/constants';
import type { BadgeTone } from './index';

/** Badge tone per tournament role — the same colours everywhere a role is shown. */
export const ROLE_BADGE_TONE: Record<TournamentRole, BadgeTone> = {
  [TOURNAMENT_ROLES.HOLDER]: 'orange',
  [TOURNAMENT_ROLES.MAINTAINER]: 'azure',
  [TOURNAMENT_ROLES.PARTICIPANT]: 'olive',
};

/** Badge tone per participant status. */
export const PARTICIPANT_STATUS_BADGE_TONE: Record<ParticipantStatus, BadgeTone> = {
  [PARTICIPANT_STATUSES.ACTIVE]: 'grass',
  [PARTICIPANT_STATUSES.BLOCKED]: 'red',
  [PARTICIPANT_STATUSES.AWAITING]: 'orange',
};

/** Badge tone per tournament list status. */
export const TOURNAMENT_STATUS_BADGE_TONE: Record<TournamentStatus, BadgeTone> = {
  [TOURNAMENT_STATUSES.ACTIVE]: 'grass',
  [TOURNAMENT_STATUSES.UPCOMING]: 'azure',
  [TOURNAMENT_STATUSES.FINISHED]: 'muted',
};
